import { z } from 'zod';
import { badgeTemplateClassifierSnapshotSchema } from '../entities/BadgeEntityTypes';
import { accountBadgeAccountRequestSchema } from '../schema/commonRequestSchema';
import { accountBadgeResponseSchema, badgeResponseSchema } from '../schema/commonResponseSchema';
export const createBadgeRequestSchema = z.object({
    badgeName: z.string(),
    badgeDescription: z.string().optional(),
    expirationIntervalMonths: z.number().positive(),
    badgeTemplate: badgeTemplateClassifierSnapshotSchema,
    formSettings: z.object({}).passthrough(),
    organizationsAdminsCanAssignBadges: z.string().uuid().array().optional(),
    accounts: accountBadgeAccountRequestSchema.array().optional(),
});
export const createBadgeResponseSchema = z.object({
    badge: badgeResponseSchema,
    accountBadges: accountBadgeResponseSchema.array(),
});
export const createBadgeFunctionDef = {
    name: 'createBadge',
    requestSchema: createBadgeRequestSchema,
    responseSchema: createBadgeResponseSchema,
};
